export default {
  namespaced: true,
  state: {
    isVisible: false
  },
  getters: {
    getIsVisible: (state) => state.isVisible
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    }
  },
  actions: {}
}
